import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';

import Clipboard from 'clipboard';


ReactModal.setAppElement('#sharing-container');

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content : {
  	padding				        : '1rem',
	  width				          : 'auto',
	  maxWidth			        : '800px',
	  height				        : 'auto',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

class Sharing extends React.Component {
  constructor () {
    super();
    this.state = {
      showModal: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.popupHandler = this.popupHandler.bind(this);

    this.clipboard = new Clipboard('.clicktocopy');
	this.clipboard.on('success', function(e) {
		alert('URL Copied');
	});
  }

  popupHandler = (e) => {

    var Config = {
        Width: 800,
        Height: 500
    };
        e = (e ? e : window.event);
    var t = (e.target ? e.target : e.srcElement);

    // popup position
    var px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
        py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

    // open popup
    var popup = window.open(t.href, "social",
        "width="+Config.Width+",height="+Config.Height+
        ",left="+px+",top="+py+
        ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
    if (popup) {
        popup.focus();
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
    }
    return !!popup;
  }

  handleOpenModal () {
    this.setState({ showModal: true });
  }

  handleCloseModal () {
    this.setState({ showModal: false });
  }

  render () {
    return (
      <div className="sharing">

        <div className="sharing-icon" onClick={this.handleOpenModal}>
          <div className="modal-dots" aria-label="modal-button" name="modal-button"></div>
          <div className="sharing-text">Share</div>
        </div>

        <ReactModal
           isOpen={this.state.showModal}
           style={ModalStyles}
           contentLabel="Sharing Modal"
        >
        <div className="sharing sharing-modal">
          <h3>Share</h3>
          <h4>{this.props.title}</h4>
          <div className="share-item">
            <a href={this.props.facebook} title="Share on Facebook" onClick={this.popupHandler}>
              <span className="icon share facebook-share"></span><p>Share on Facebook</p>
            </a>
          </div>
          <div className="share-item">
            <a href={this.props.twitter} title="Share on Twitter" onClick={this.popupHandler}>
              <span className="icon share twitter-share"></span><p>Share on Twitter</p>
            </a>
          </div>
          <div className="share-item">
            <a href={this.props.email} title="Share by Email" >
              <span className="icon icon-envelope share-email"></span><p>Share via Email</p>
            </a>
          </div>
          <div className="share-item hide-for-medium">
            <a href={this.props.fb} title="Share on Messenger"><span className="icon messenger"></span><p>Share on Messenger</p></a>
          </div>
          <div className="share-item last">
            <button className="clicktocopy" data-clipboard-text={this.props.url} title="Copy to Clipboard">
              <span className="icon icon-copy"></span><p>Copy to Clipboard</p>
            </button>
          </div>
          <button className="close-button" onClick={this.handleCloseModal}><span className="icon icon-cross"></span></button>
        </div>
        </ReactModal>
      </div>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
    const props = {};
    const sharing = document.querySelector('#sharing-container');
    const title = sharing.getAttribute('data-title');
    const url = sharing.getAttribute('data-url');
    const fb = sharing.getAttribute('data-fb');
    const fbb = sharing.getAttribute('data-fbb');
    const facebook = sharing.getAttribute('data-facebook');
    const twitter = sharing.getAttribute('data-twitter');
    const email = sharing.getAttribute('data-email');
    ReactDOM.render(
        <Sharing url={url} fb={fb} fbb={fbb} title={title} facebook={facebook} twitter={twitter} email={email}/>,
        sharing,
    )
});
